<template>
  <article class="cmp cmp-product-thumb cmp-product-thumb--modern" :data-testing="item && item.variation ? item.variation.id : ''">
    <div v-if="item" :class="paddingClasses" :style="paddingInlineStyles">
      <div class="thumb-content">
                
        <a 
          :href="item | itemURL(urlWithVariationId)" 
          class="player-name"
          @mouseover="showTop5Tooltip = isTopItem || isTopInteractions()"
          @mouseleave="showTop5Tooltip = false"
        >
          <span v-if="(isTopItem || isTopInteractions()) && showTop5Tooltip" class="custom-tooltip top5-tooltip">Top 5 Community Gerücht</span>
          {{ item | itemName }}<span v-if="isTopItem || isTopInteractions()" class="trending-text ml-1">🔥</span>
        </a>
        
        <div v-if="probability()" class="probability-info d-flex align-items-center">
            <!--  @mouseover="showTooltip = true" @mouseleave="showTooltip = false" <div v-if="showTooltip" class="custom-tooltip">Unsere Einschätzung</div> -->
            <i class="fa fa-refresh"></i>
            <span class="probability-value">
                Unsere Wechseleinschätzung:
              <template v-if="probability() === '?'">{{ probability() }}</template>
              <template v-else>{{ probability() }}%</template>
            </span>
            <i v-if="progression() === 'Steigend'" class="fa fa-angle-double-up trend-icon ml-2"></i>
            <i v-if="progression() === 'Fallend'" class="fa fa-angle-double-down trend-icon ml-2"></i>
        </div>
        
        <div class="position-info" v-if="position()">
          <i class="fa fa-map-marker"></i>
          <span>{{ position() }}</span>
        </div>

        <div class="market-value mb-3">
          <i class="fa fa-eur"></i>
          <span>{{ marketValue() }} €</span>
        </div>
        
        <div class="info-button-group" v-if="probability() || (fromClub() && toClub())">
            <!-- Transfer Box -->
          <div class="transfer-box" v-if="fromClub() && toClub()">
            <div class="transfer-club current">            
              <span class="club-label">Aktuell</span>
              <span class="club-name">
                <slot name="from-club-name"></slot>
              </span>
            </div>
            
            <i class="fa fa-long-arrow-right transfer-arrow"></i>
            
            <div class="transfer-club target">            
              <span class="club-label">Ziel</span>
              <span class="club-name">
                <slot name="to-club-name"></slot>
              </span>
            </div>
          </div>
        </div>

        <!-- Closed State Overlay -->
        <div class="closed-overlay" v-if="item && isClosed()">
          <a :href="item | itemURL(urlWithVariationId)" class="closed-message">
            <i class="fa fa-lock"></i>
            <span>Gerücht geschlossen</span>
          </a>
        </div>

        <!-- 4. Fan Feedback Section - Lazy Loaded Widgets -->
        <div v-if="item && item.variation" class="community-insight-wrapper">
          <!-- Widgets Content -->
          <div v-show="shouldLoadWidgets" class="community-insight">
            <h3 class="insight-title">Fan Feedback</h3>
            
            <!-- Login Info -->
            <div v-if="!isLoggedIn" class="alert alert-warning mb-2 text-center px-0">              
                <a href="javascript:void(0)" @click="openRegisterModal" class="alert-link small py-2 px-3" style="cursor: pointer;">
                    <i class="fa fa-info-circle mr-1"></i>Fan-Konto erstellen & mitbestimmen
                </a>
            </div>
            
            <!-- 1. Vote Widget (Würde der Spieler passen?) -->
            <div class="widget-section">
              <vote-widget 
                reference-type="item" 
                :reference-id="item.variation.id" 
                :show-title="false"
                :initial-thumbs-up="thumbsUpFromProperty()"
                :initial-thumbs-down="thumbsDownFromProperty()"
              />
            </div>
            
            <!-- Widget Divider -->
            <div class="widget-divider"></div>
            
            <!-- 2. Rumor Probability Widget (Wechselwahrscheinlichkeit) -->
            <div class="widget-section">
              <rumor-probability-widget 
                :variation-id="item.variation.id" 
                :show-title="false"
                :initial-average-probability="averageProbabilityFromProperty()"
                :initial-count="probabilityCountFromProperty()"
              />
            </div>
            
            <!-- Widget Divider -->
            <div class="widget-divider"></div>
            
            <!-- 3. Team Impact Display (read-only) -->
            <div class="widget-section">
              <team-impact-display
                reference-type="item"
                :reference-id="item.variation.id"
                :show-title="true"
                :item-data="item"
                :initial-rating1="teamImpactRating1FromProperty()"
                :initial-rating2="teamImpactRating2FromProperty()"
                :initial-rating3="teamImpactRating3FromProperty()"
                :initial-rating4="teamImpactRating4FromProperty()"
                :initial-rating5="teamImpactRating5FromProperty()"
              />
            </div>
          </div>
        </div>

        <!-- 6. Button Group: CTA Button + Wishlist Button -->
        <div class="action-button-group" v-if="item && item.variation">
          <!-- Zum Lieblingsspieler Button -->
          <a :href="item | itemURL(urlWithVariationId)" class="action-btn lieblings-btn">            
            <span>Zum Fanliebling</span>
            <i class="fa fa-long-arrow-right" aria-hidden="true"></i>
          </a>
          
          <!-- Wunschliste Button -->
          <div class="action-btn wishlist-btn-wrapper">
            <add-to-wish-list :variation-id="item.variation.id"></add-to-wish-list>
          </div>
        </div>

      </div>
    </div>
  </article>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import CategoryImageCarousel from "./CategoryImageCarousel.vue";
import ItemStoreSpecial from "./ItemStoreSpecial.vue";
import AddToWishList from "../item/AddToWishList.vue";
import { getSlotData } from "../../helper/getSlotData";

export default {
  components: {
    CategoryImageCarousel,
    ItemStoreSpecial,
    AddToWishList,
  },

  props: {
    decimalCount: {
      type: Number,
      default: 0,
    },
    imageUrlAccessor: {
      type: String,
      default: "urlMiddle",
    },
    itemData: {
      type: Object,
    },
    disableCarouselOnMobile: {
      type: Boolean,
    },
    paddingClasses: {
      type: String,
      default: null,
    },
    paddingInlineStyles: {
      type: String,
      default: null,
    },
    forceUrlWithVariationId: {
      type: Boolean,
      default: false,
    },
    itemIndex: {
      type: Number,
      default: 0,
    },
    isTopItem: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      maxValue: 1,
      currentValue: 0,
      showTooltip: false,
      showTop5Tooltip: false,
      targetValue: 0,
      progressWidth: 0,
      isVisible: false,
      observer: null,
    };
  },

  jsonDataFields: ["itemDataRef"],

  computed: {
    widgetsEnabled() {
      // Responsive Breakpoints für Initial Load
      // Desktop (>= 992px): 8 Artikel
      // Tablet (768px - 991px): 6 Artikel
      // Mobile (< 768px): 2 Artikel
      
      // SSR-safe: Check if window exists (client-side only)
      if (typeof window === 'undefined') {
        // Server-side: use desktop default
        return this.itemIndex < 8;
      }
      
      const width = window.innerWidth;
      let initialLoadCount;
      
      if (width >= 992) {
        initialLoadCount = 8;
      } else if (width >= 768) {
        initialLoadCount = 6;
      } else {
        initialLoadCount = 2;
      }
      
      return this.itemIndex < initialLoadCount;
    },
    
    shouldLoadWidgets() {
      // Wenn widgetsEnabled false ist (Artikel außerhalb initial range),
      // warte auf Intersection Observer
      if (!this.widgetsEnabled) {
        return this.isVisible;
      }
      // Wenn widgetsEnabled true ist (erste N Artikel), lade sofort
      return true;
    },
    
    item() {
      const item = this.itemData || this.itemSlotData || this.itemDataRef;      
      return item;
    },

    itemSlotData: getSlotData("item-data"),

    // procent() {
    //   const numericMaxValue = this.maxValue || 1;
    //   const numericCurrentValue = this.currentValue || 0;

    //   if (numericMaxValue === 0) return 0; // Verhindert Division durch 0

    //   const percentValue = (numericCurrentValue / numericMaxValue) * 100;
    //   return percentValue;
    // },

    /**
     * returns itemData.item.storeSpecial
     */
    storeSpecial() {
      if (!this.item?.item) return null;
      return this.item.item.storeSpecial;
    },

    badge() {
      const sales = this.sales();
      if (!sales) return null;

      if (sales >= 5 && sales < 10) {
        return { text: "<i class='fa fa-rocket'></i> Dein Support zählt!", color: "secondary" };
      } else if (sales >= 10 && sales < 20) {
        return { text: "<i class='fa fa-fire'></i> Beliebt", color: "warning" };
      } else if (sales >= 20 && sales <= 30) {
        return { text: "<i class='fa fa-star'></i> Sehr gefragt", color: "info" };
      } else if (sales > 30) {
        return { text: "<i class='fa fa-trophy'></i> Bestseller", color: "success" };
      }
    },

    /**
     * returns itemData.texts
     */
    texts() {
      if (!this.item) return null;
      return this.item.texts;
    },

    tagName() {
      if (!this.item?.tags) return null;
      const tag = this.item.tags?.[0];
      return tag?.id === 1 ? tag?.names?.name || null : null;
    },

    itemPrice() {
      if (!this.item?.prices?.default) return null;
      return this.$options.filters.specialOffer(this.item.prices.default.unitPrice.formatted, this.item.prices, "unitPrice", "formatted");
    },

    basePrice() {
      if (!this.item?.prices?.default) return null;
      return this.item.prices.default.basePrice;
    },

    itemPriceGraduated() {
      if (!this.item?.prices) return null;
      
      let unitPrice;
      if (App.config.item.enableGraduatedPrices) {
        unitPrice = this.item.prices.graduatedPrices?.length > 0 ? this.item.prices.graduatedPrices[0].unitPrice : this.item.prices.default.unitPrice;
      } else {
        unitPrice = this.item.prices.default.unitPrice;
      }

      return this.$options.filters.specialOffer(unitPrice.formatted, this.item.prices, "unitPrice", "formatted");
    },

    itemGraduatedPriceisCheapestSorting() {
      if (!this.item?.item) return false;
      return !!this.item.item && this.item.item.salableVariationCount > 1 && !!this.$ceres.isCheapestSorting;
    },

    itemGraduatedPricesalableVariationCount() {
      if (!this.item?.item || !this.item?.prices) return false;
      return !!this.item.item && this.item.item.salableVariationCount == 1 && this.item.prices.graduatedPrices?.length > 1 && App.config.item.enableGraduatedPrices;
    },

    itemSetPrice() {
      if (!this.item?.prices?.default) return null;
      return this.$options.filters.currency(this.item.prices.default.price.value, this.item.prices.default.currency);
    },

    urlWithVariationId() {
      return !this.$ceres.config.item.showPleaseSelect || this.$ceres.initialPleaseSelect == 0 || this.forceUrlWithVariationId;
    },

    hasCrossPrice() {
      if (!this.item?.prices) return false;
      
      const hasRrpPrice = !!this.item.prices.rrp && this.item.prices.rrp.unitPrice.value > this.item.prices.default.unitPrice.value;

      const hasBeforePrice = !!this.item.prices.specialOffer && !!this.item.prices.default && this.item.prices.default.unitPrice.value > this.item.prices.specialOffer.unitPrice.value;

      return hasRrpPrice || hasBeforePrice;
    },

    ...mapState({
      showNetPrices: (state) => state.basket.showNetPrices,
    }),

    ...mapGetters(["isLoggedIn"]),
  },

  mounted() {
    // Werte holen und sicherstellen, dass sie numerisch sind
    const marketValueRaw = this.marketValue();
    const remainingStockRaw = this.remainingStock();

    const marketValueInt = parseInt(marketValueRaw.replace(/\D/g, ""), 10) || 1;
    const remainingStock = parseInt(remainingStockRaw.replace(/\D/g, ""), 10) || 0;

    // Zielwert basierend auf dem Marktwert festlegen
    let targetValue;
    if (marketValueInt <= 2000000) {
      targetValue = 800000;
    } else if (marketValueInt <= 10000000) {
      targetValue = 1500000;
    } else {
      targetValue = 5000000;
    }

    // Fortschrittsbreite berechnen
    const consumedValue = marketValueInt - remainingStock;
    this.progressWidth = ((consumedValue / (marketValueInt - targetValue)) * 100).toFixed(2);
    
    // Intersection Observer für Artikel außerhalb der initial range
    if (!this.widgetsEnabled && this.item && this.item.variation) {
      this.setupIntersectionObserver();
    }
  },
  
  beforeDestroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
  },

  methods: {
    setupIntersectionObserver() {
      const options = {
        root: null,
        rootMargin: '300px',
        threshold: 0.01
      };
      
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting && !this.isVisible) {
            this.isVisible = true;
            // Observer disconnecten nach dem ersten Trigger
            if (this.observer) {
              this.observer.disconnect();
            }
          }
        });
      }, options);
      
      // Observe the article element
      this.observer.observe(this.$el);
    },
    
    sales() {
      if (this.item?.variationProperties) {
        for (let property of this.item.variationProperties) {
          if (property.properties) {
            const result = property.properties.find((prop) => prop.id === 77);
            if (result?.values) {
              const value = parseInt(result.values.value, 10); // <<< String zu Integer
              return isNaN(value) ? false : value; // Falls parseInt fehlschlägt, gib false zurück
            }
          }
        }
      }
      return false;
    },
    probability() {
      if (this.item?.variationProperties) {
        for (let property of this.item.variationProperties) {
          if (property.properties) {
            const result = property.properties.find((prop) => prop.id === 63);
            if (result?.values) {
              return result.values.value || false;
            }
          }
        }
      }
      return false;
    },
    progression() {
      if (this.item?.variationProperties) {
        for (let property of this.item.variationProperties) {
          if (property.properties) {
            const result = property.properties.find((prop) => prop.id === 64);
            if (result?.values) {
              const value = result.values.value;
              // Rückgabe der entsprechenden Werte
              if (value === "-1") {
                return "Fallend";
              } else if (value === "1") {
                return "Steigend";
              }

              return false; // Rückgabe false für nicht erkannte Werte
            }
          }
        }
      }
      return false; // Rückgabe false, falls keine Werte gefunden werden
    },
    isClosed() {
      if (this.item?.variationProperties) {
        for (let property of this.item.variationProperties) {
          if (property.properties) {
            const result = property.properties.find((prop) => prop.id === 62);
            if (result?.values && typeof result.values.value === "string" && result.values.value.trim() !== "") {
              return true;
            }
          }
        }
      }
      return false;
    },
    fromClub() {
      if (this.item?.variationProperties) {
        for (let property of this.item.variationProperties) {
          if (property.properties) {
            const result = property.properties.find((prop) => prop.id === 61);
            if (result?.values) {
              return result.values.value || false;
            }
          }
        }
      }
      return false;
    },
    toClub() {
      if (this.item?.variationProperties) {
        for (let property of this.item.variationProperties) {
          if (property.properties) {
            const result = property.properties.find((prop) => prop.id === 60);
            if (result?.values) {
              return result.values.value || false;
            }
          }
        }
      }
      return false;
    },
    position() {
      if (this.item?.variationProperties) {
        for (let property of this.item.variationProperties) {
          if (property.properties) {
            const result = property.properties.find((prop) => prop.id === 73);
            if (result?.values) {
              return result.values.value || false;
            }
          }
        }
      }
      return false;
    },

    marketValue() {
      if (this.item?.variationProperties) {
        for (let property of this.item.variationProperties) {
          if (property.properties) {
            const result = property.properties.find((prop) => prop.id === 58);
            if (result?.values) {
              const value = Number(result.values.value); // Stelle sicher, dass es eine Zahl ist

              return value.toLocaleString("de-DE");
            }
          }
        }
      }
      return "1";
    },

    remainingStock() {
      if (this.item?.variationProperties) {
        for (let property of this.item.variationProperties) {
          if (property.properties) {
            const result = property.properties.find((prop) => prop.id === 74);
            if (result?.values) {
              return result.values.value || "0";
            }
          }
        }
      }
      return "0";
    },

    hasProperty82() {
      if (this.item?.variationProperties) {
        for (let property of this.item.variationProperties) {
          if (property.properties) {
            const result = property.properties.find((prop) => prop.id === 82);
            if (result) {
              return true; // Eigenschaft ID 82 ist vorhanden
            }
          }
        }
      }
      return false; // Eigenschaft ID 82 ist nicht vorhanden
    },
    
    isTopInteractions() {
      if (this.item?.variationProperties) {
        for (let property of this.item.variationProperties) {
          if (property.properties) {
            const result = property.properties.find((prop) => prop.id === 94); // Top 5 Flag
            if (result?.values) {
              const value = result.values.value;
              // Akzeptiere jeden Wert ("1", "3", "true", true, etc.)
              // Solange Property 94 existiert und einen Wert hat
              return value != null && value !== "" && value !== "0" && value !== 0 && value !== false;
            }
          }
        }
      }
      return false;
    },
    
    // Property 87: Durchschnittliche Wahrscheinlichkeit (für Rumor Probability Widget)
    averageProbabilityFromProperty() {
      if (this.item?.variationProperties) {
        for (let property of this.item.variationProperties) {
          if (property.properties) {
            const result = property.properties.find((prop) => prop.id === 87);
            if (result?.values) {
              const value = parseFloat(result.values.value);
              return !isNaN(value) ? value : null;
            }
          }
        }
      }
      return null;
    },
    
    // Property 95: Anzahl der Votes (für Rumor Probability Widget)
    probabilityCountFromProperty() {
      if (this.item?.variationProperties) {
        for (let property of this.item.variationProperties) {
          if (property.properties) {
            const result = property.properties.find((prop) => prop.id === 95);
            if (result?.values) {
              const value = parseInt(result.values.value, 10);
              return !isNaN(value) ? value : null;
            }
          }
        }
      }
      return null;
    },    
    // Property 85: Thumbs Up Count (für Vote Widget)
    thumbsUpFromProperty() {
      if (this.item?.variationProperties) {
        for (let property of this.item.variationProperties) {
          if (property.properties) {
            const result = property.properties.find((prop) => prop.id === 85);
            if (result?.values) {
              const count = parseInt(result.values.value, 10);
              return isNaN(count) ? 0 : count;
            }
          }
        }
      }
      return 0;
    },
    
    // Property 86: Thumbs Down Count (für Vote Widget)
    thumbsDownFromProperty() {
      if (this.item?.variationProperties) {
        for (let property of this.item.variationProperties) {
          if (property.properties) {
            const result = property.properties.find((prop) => prop.id === 86);
            if (result?.values) {
              const count = parseInt(result.values.value, 10);
              return isNaN(count) ? 0 : count;
            }
          }
        }
      }
      return 0;
    },
    
    // Property 92: Team Impact Rating 1 - Schwächung (für Team Impact Display)
    teamImpactRating1FromProperty() {
      if (this.item?.variationProperties) {
        for (let property of this.item.variationProperties) {
          if (property.properties) {
            const result = property.properties.find((prop) => prop.id === 92);
            if (result?.values) {
              const count = parseInt(result.values.value, 10);
              return isNaN(count) ? 0 : count;
            }
          }
        }
      }
      return 0;
    },
    
    // Property 91: Team Impact Rating 2 - Kaum Effekt (für Team Impact Display)
    teamImpactRating2FromProperty() {
      if (this.item?.variationProperties) {
        for (let property of this.item.variationProperties) {
          if (property.properties) {
            const result = property.properties.find((prop) => prop.id === 91);
            if (result?.values) {
              const count = parseInt(result.values.value, 10);
              return isNaN(count) ? 0 : count;
            }
          }
        }
      }
      return 0;
    },
    
    // Property 90: Team Impact Rating 3 - Kaderbreite (für Team Impact Display)
    teamImpactRating3FromProperty() {
      if (this.item?.variationProperties) {
        for (let property of this.item.variationProperties) {
          if (property.properties) {
            const result = property.properties.find((prop) => prop.id === 90);
            if (result?.values) {
              const count = parseInt(result.values.value, 10);
              return isNaN(count) ? 0 : count;
            }
          }
        }
      }
      return 0;
    },
    
    // Property 89: Team Impact Rating 4 - Klare Verstärkung (für Team Impact Display)
    teamImpactRating4FromProperty() {
      if (this.item?.variationProperties) {
        for (let property of this.item.variationProperties) {
          if (property.properties) {
            const result = property.properties.find((prop) => prop.id === 89);
            if (result?.values) {
              const count = parseInt(result.values.value, 10);
              return isNaN(count) ? 0 : count;
            }
          }
        }
      }
      return 0;
    },
    
    // Property 88: Team Impact Rating 5 - Gamechanger (für Team Impact Display)
    teamImpactRating5FromProperty() {
      if (this.item?.variationProperties) {
        for (let property of this.item.variationProperties) {
          if (property.properties) {
            const result = property.properties.find((prop) => prop.id === 88);
            if (result?.values) {
              const count = parseInt(result.values.value, 10);
              return isNaN(count) ? 0 : count;
            }
          }
        }
      }
      return 0;
    },
    
    /**
     * Öffnet das Registrierungs-Modal
     */
    openRegisterModal(event) {
      // Verhindere Default-Link-Behavior und Scrollen
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }
      
      // Lade das Modal via Store (wenn noch nicht geladen)
      if (this.$store && this.$store.dispatch) {
        this.$store.dispatch('loadComponent', 'login-modal');
      }
      // SSR-safe: Only run on client
      if (typeof window === "undefined" || typeof document === "undefined") {
        return;
      }
      
      // Speichere die aktuelle Scroll-Position
      const scrollY = window.scrollY;
      
      // Warte auf die geladene Komponente, dann öffne das Modal
      const checkAndOpenModal = () => {
        const modalElement = document.getElementById('login');
        if (modalElement && window.$) {
          // Prüfe, ob die Login-Komponente geladen wurde
          const isComponentLoaded = this.$store && this.$store.state.lazyComponent 
            && this.$store.state.lazyComponent.components['login-modal'];
          
          if (isComponentLoaded || document.querySelector('#login .tab-pane#tab1 login')) {
            // Event-Listener für Modal-Close, um Scrollen zu verhindern
            window.$('#login').one('hidden.bs.modal', function() {
              // Stelle die Scroll-Position wieder her
              window.scrollTo(0, scrollY);
            });
            
            // Verwende Bootstrap's native Event-System
            window.$('#login').modal('show');
          } else {
            // Komponente noch nicht geladen, warte noch etwas
            setTimeout(checkAndOpenModal, 100);
          }
        }
      };
      
      setTimeout(checkAndOpenModal, 150);
    },
  },
};
</script>
